export const eventGetAttrsMixin = {
  methods: {
    getAttrValue(attrs, attrName) {

      if (!attrs || !attrName) {
        return null;
      }
      const attr = attrs.find(attr => attr.postAttrNm === attrName);
      return attr ? attr.postAttrVal : null;
    },
  },
};